import { Outlet, useLocation } from "react-router-dom";

import { useStoreUrlParams } from "@/features/onboarding/hooks";
import { useEverflowClick } from "@/features/onboarding/hooks/use-everflow-click";
import { ONBOARDING_ROUTE } from "@/features/onboarding/router";
import { LanguageButton, LanguageSwitch } from "@/shared/components";
import { useLanguageFromParams } from "@/shared/hooks";
import { useMouseflowSession } from "@/shared/lib/mouseflow/hooks/use-mouseflow-session";
import { Layout } from "@/shared/ui";

const ONBOARDING_STEPS = [
  ONBOARDING_ROUTE.BMI,
  ONBOARDING_ROUTE.ELIGIBILITY_QUESTIONS,
  ONBOARDING_ROUTE.ACCOUNT_PERSONAL_DETAILS,
  ONBOARDING_ROUTE.ACCOUNT_CONTACT_DETAILS,
  ONBOARDING_ROUTE.CHOOSE_TREATMENT,
  ONBOARDING_ROUTE.ACCOUNT_PASSWORD,
];

export const OnboardingLayout = () => {
  useLanguageFromParams();
  useEverflowClick();
  useStoreUrlParams();
  useMouseflowSession();

  const { pathname } = useLocation();

  const currentStepIndex = ONBOARDING_STEPS.findIndex((step) =>
    pathname.startsWith(step),
  );

  const progress = ((currentStepIndex + 1) / ONBOARDING_STEPS.length) * 100;

  return (
    <div className="flex h-dvh flex-col bg-white">
      <Layout.Header
        // leftSlot={<PhoneContact className="hidden sm:inline-flex" />}
        rightSlot={
          <div className="flex items-center gap-3">
            {/* <PhoneButton className="sm:hidden" /> */}

            <>
              <LanguageSwitch className="hidden sm:inline-flex" />

              <LanguageButton className="sm:hidden" />
            </>
          </div>
        }
        progress={progress}
      />

      <Outlet />
    </div>
  );
};
